import { get as _get } from 'lodash';

import { windowCheck } from '../helpers';

export const gaTrackSignupModalOpened = () => {
  if (windowCheck) {
    window.ga && window.ga(
      'send',
      'event',
      'Account',
      'Signup Modal Opened',
      window.currentLocation
    );
    window.dataLayer && window.dataLayer.push({
      event: 'Signup Modal Opened',
      ref_page: window.currentLocation,
      eventCallback: () => {
        console.log('Signup Modal Opened: fired');
      },
    });
  }
};

export const gaTrackSignupError = error => {
  if (windowCheck) {
    window.datalayer && window.dataLayer.push({
      event: 'Failed Account Creation',
      reason: error,
      eventCallback: () => {
        console.log('Failed Account Creation');
      },
    });
  }
};

// GTM event name: 'sign_up', GTM Trigger: 'GA4 - Signup Completed - marketing site'
export const gaSignupSuccess = (accountID, refEmployees) => {
  if (windowCheck) {
    try {
      // if gtm is being blocked, move on
      if (!_get(window, 'google_tag_manager.dataLayer.gtmLoad', false)) {
        return;
      } else {
        window.dataLayer && window.dataLayer.push({
          event: 'sign_up',
          method: 'WIW',
          expectedEmployees: refEmployees,
          account_id: accountID,
          eventCallback: () => {
            console.log(
              'Signup Successful',
              accountID,
              refEmployees,
            );
          },
        });
      }
    } catch (error) {
      console.log('GA Response Failed', error);
    }
  }
}

export function gaTrackDownloads(results) {
  if (windowCheck) {
    window.ga && window.ga(
      'send',
      'event',
      'Vero',
      'Content Download',
      results.contentTitle
    );
    try {
      // if gtm is being blocked, move on
      if (!_get(window, 'google_tag_manager.dataLayer.gtmLoad', false)) {
        return;
      } else {
        window.dataLayer && window.dataLayer.push({
          event: 'GA Event - Blog Content Download',
          category: 'Vero',
          action: 'Content Download',
          label: results.contentTitle,
          eventCallback: () => {
            console.log(
              'Response Was Successful: ga',
              'GA Event - Blog Content Download',
              'Vero',
              'Content Download',
              results.contentTitle
            );
          },
        });
      }
    } catch (error) {
      console.log('Response Was Failed: ga', error);
    }
  }
}

export function gaTrackBlogSubscriptions(results) {
  if (windowCheck) {
    window.ga && window.ga(
      'send',
      'event',
      'Vero',
      'Blog Subscriptions',
      results.contentTitle
    );
    try {
      // if gtm is being blocked, move on
      if (!_get(window, 'google_tag_manager.dataLayer.gtmLoad', false)) {
        return;
      } else {
        window.dataLayer && window.dataLayer.push({
          event: 'GA Event - Blog Subscription',
          category: 'Vero',
          action: 'Blog Subscription',
          label: results.contentTitle,
          eventCallback: () => {
            console.log(
              'Response Was Successful: ga',
              'GA Event - Blog Subscription',
              'Vero',
              'Blog Subscription',
              results.contentTitle
            );
          },
        });
      }
    } catch (error) {
      console.log('Response Was Failed: ga', error);
    }
  }
}

export function gaTrackInlineCtaClicks(id, page) {
  if (windowCheck) {
    window.ga && window.ga(
      'send',
      'event',
      'Inline CTA',
      'Clicked',
      `${id} on ${page}`
    );
    try {
      // if gtm is being blocked, move on
      if (!_get(window, 'google_tag_manager.dataLayer.gtmLoad', false)) {
        return;
      } else {
        window.dataLayer && window.dataLayer.push({
          event: 'GA Event - Inline CTA Click',
          category: 'Inline CTA',
          action: 'Click',
          label: `${id} on ${page}`,
          eventCallback: () => {
            console.log(
              'Response Was Successful: ga',
              'GA Event - Inline CTA Clock',
              'Inline CTA',
              'Click',
              `${id} on ${page}`
            );
          },
        });
      }
    } catch (error) {
      console.log('Response Was Failed: ga', error);
    }
  }
}
